import React from 'react'
import { MailRef } from '../../styles'
import { useTranslation } from 'react-i18next'
import { Table } from 'antd'
import Mail from 'globals/models/Mail'
import MailProcessing from 'components/MailProcessing'
import { ArrowRightIcon } from 'components/Icons'
import DataTable from 'components/DataTable'

interface IProps {
  data: Mail[],
  selectedMailsIds: React.Key[],
  setSelectedMailsIds: (selectedMailsIds: React.Key[]) => void,
  onMailClicked: (mail: Mail) => void,
  hideHeader?: boolean,
  currentPage?: number,
  pageSize?: number,
  showPackages?: boolean,
  shouldHideCheckbox: (mail: Mail) => boolean,
  alwaysHideCheckboxes?: boolean,
  alwaysShowCheckboxes?: boolean,
  showAddTrackingNumber?: boolean,
  disable?: boolean,
  quickAction?: string,
  quickActionCallback?: any
}

const DataTableClient = (props: IProps) => {
  const { data, selectedMailsIds, setSelectedMailsIds, hideHeader, currentPage,
    pageSize, shouldHideCheckbox, disable, onMailClicked } = props
  const { t } = useTranslation()

  return (
    <DataTable
      data={data}
      selectedData={selectedMailsIds}
      setSelectedData={setSelectedMailsIds}
      currentPage={currentPage}
      pageSize={pageSize}
      shouldHideCheckbox={shouldHideCheckbox}
      hideHeader={hideHeader}
      selectableRows
      disable={disable}
      onRow={(mail: Mail) => {
        return {
          onClick: () => {
            onMailClicked(mail)
          }
        }
      }}
    >

      <Table.Column
        key="id"
        dataIndex="id"
        title={t('mails.ref-sd')}
        className="small"
        render={(id) => <MailRef>{id}</MailRef> }
        width={120}
      />

      <Table.Column
        key="id"
        dataIndex="idScaneco"
        title={t('mails.ref-scaneco')}
        className="small"
        render={(id) => <MailRef>{id}</MailRef> }
        width={160}
      />

      <Table.Column
        key="mailType"
        dataIndex="mailType"
        title={t('mails.type')}
        className="medium"
        render={(mailType) => t('mails.types.' + mailType) }
        width={120}
      />

      <Table.Column
        key="mailType"
        dataIndex="mailType"
        title={t('mails.type')}
        className="medium"
        width={260}
        render={(type, mail: Mail) =>
          <MailProcessing
            processingType={mail.processingType}
            processingDate={mail.processingDate}
            customerRequest={mail.hasUserRequest}
          />
        }
      />

      <Table.Column
        key="sendName"
        dataIndex="sendName"
        title={t('mails.sender')}
        render={(sendName) =>
          sendName || '-'
        }
      />

      <Table.Column
        key="hasScanFile"
        title={t('mails.scanned')}
        width={180}
        render={(mail: Mail) => {
          return mail.scanFile &&
            <a onClick={(e) => {
              window.open(mail.scanFile, '_blank')?.focus()
              e.stopPropagation()
            }}>
              {t('mails.preview')}
            </a>
        }}
      />

      <Table.Column
        key="action"
        title=""
        width={40}
        render={(t, mail: Mail) =>
          <ArrowRightIcon onClick={() => onMailClicked(mail)} />
        }
      />
    </DataTable>
  )
}

export default DataTableClient
